var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'creation-container container-' +  _vm.container.tag},_vm._l((_vm.container.modules),function(mod,i){return _c('app-mod',{key:i,attrs:{"mod":mod,"tag":_vm.container.tag,"refId":i}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }